import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { TextBox, DatePicker, Switch } from 'fw/forms';
import { Label } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class DiscountCodeInfoTab extends SetupTab {
    initialForm() {
        return {
			discountCodeId: null,
            active: false,
            rowVersion: null
        }
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminDiscountCodeSetupEdit")
        }
    }

    urls() {
        return {
            get: API.DiscountCode.url('/discountCodeSetup/getDiscountCodeInfo'),
            save: API.DiscountCode.url('/discountCodeSetup/saveDiscountCodeInfo'),
        }
    }

    getRequest(selectedId) {
		return {
            discountCodeId: selectedId
        }
    }

    saveRequest() {
        return {
            discountCodeId: this.props.selectedId,
            active: this.state.form.active,
            rowVersion: this.state.form.rowVersion
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <Label required>Discount Code</Label>
                            <TextBox 
                                name="code" 
                                placeholder="Code"
                                maxLength={8}
								disabled={true}
                                />
                        </FormGroup>
                    </Col>
					<Col md={2}>
						<FormGroup>
							<Label required>Expiration date</Label>
							<DatePicker
								name='expirationDate'
								placeholder='Select Date'
								showTime={false}
								disabled={true}
								required />
						</FormGroup>
					</Col>
                    <Col md={7}>
                        <FormGroup>
                            <Label>Status</Label>
                            	<Switch name='active' labelLeft='Inactive' labelRight='Active' bsStyle='success' />
						</FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default DiscountCodeInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/discountCodeSetup/discountCodeInfo/DiscountCodeInfoTab.js